export default class AdminDocenteImportarForm {

    /**
     *
     * @param {string} data.empresaId
     * @param {string} data.empresaNombre
     */
    constructor(data){
        this.empresaId = data.empresaId;
        this.empresaNombre = data.empresaNombre;
        this.docentes = [];
    }

    /**
     *
     * @param {callback} options.onSuccess
     */
    nuevo(options) {
        let myself = this;
        let modalOpts = {
            title: 'Agregar docentes - ' + myself.empresaNombre,
            method: 'POST',
            url: '/api/admin/docentes/import'
        };
        if (options.onSuccess !== undefined) {
            modalOpts.buttons = {
                ok: {
                    label: 'Importar',
                    onSuccess: function (response) {
                        options.onSuccess(response);
                    }
                }
            }
        }
        this.modal = new FormModal(modalOpts);
        this.modal.render(this.render(), function() {
            let tbody = document.querySelector('.bootbox #docentes-para-importar tbody');
            let btnImportar = document.querySelector('.bootbox .bootbox-accept');
            let txtData = document.querySelector('.bootbox #data-importar');
            let form = document.querySelector('.bootbox form');
            btnImportar.disabled = true;
            $('.bootbox #btn-formatear-datos').click(function() {
                myself.docentes = [];
                tbody.innerHTML = '';
                if (txtData.value != '') {
                    txtData.value.split("\n").forEach(ln => {
                        if (ln != '') {
                            let arrDoc = ln.split("\t");
                            let apMat = '';
                            let correo = '';
                            if (arrDoc.length == 3) {
                                correo = arrDoc[2];
                            } else {
                                apMat = arrDoc[2];
                                correo = arrDoc[3];
                            }
                            myself.docentes.push({
                                empresa_id: myself.empresaId,
                                nombres: arrDoc[0].trim(),
                                ap_paterno: arrDoc[1].trim(),
                                ap_materno: apMat.trim(),
                                correo: correo.trim(),
                            });
                        }
                    });
                    if (myself.docentes.length > 0) {
                        myself.docentes.forEach((d, i) => {
                            tbody.innerHTML += `<tr>
                            <td>${i + 1}</td>
                            <td>${d.nombres}</td>
                            <td>${d.ap_paterno}</td>
                            <td>${d.ap_materno}</td>
                            <td>${d.correo}</td>
                            </tr>`;
                            form.innerHTML += `<input type="hidden" name="docente[${i}][empresa_id]" value="${d.empresa_id}"/>
                            <input type="hidden" name="docente[${i}][nombres]" value="${d.nombres}"/>
                            <input type="hidden" name="docente[${i}][ap_paterno]" value="${d.ap_paterno}"/>
                            <input type="hidden" name="docente[${i}][ap_materno]" value="${d.ap_materno}"/>
                            <input type="hidden" name="docente[${i}][correo]" value="${d.correo}"/>`;
                        });
                        btnImportar.disabled = false;
                    } else {
                        $.notify('No hay nada para formatear', 'info');
                    }
                } else {
                    $.notify('No hay nada para formatear', 'danger');
                }
            });
        });
    }

    render() {
        return `<div class="row form-group my-1">
        <div class="col">
        <div class="my-1">Pegar los datos de excel</div>
        <textarea class="form-control" name="data-importar" id="data-importar" placeholder="Nombres Ap. paterno Ap. Materno Correo"></textarea>
        </div>
        </div>
        <div class="row form-group my-1">
        <div class="col text-end my-2">
            <button class="btn btn-sm btn-primary" id="btn-formatear-datos">Formatear datos</button>
        </div>
        <div class="row form-group my-1">
        <div class="col-12">
            <table class="table table-sm table-bordered" id="docentes-para-importar">
                <thead>
                    <tr>
                        <td>#</td>
                        <td>Nombres</td>
                        <td>Ap. Paterno</td>
                        <td>Ap. Materno</td>
                        <td>Correo</td>
                    </tr>
                </thead>
                <tbody></tbody>
            </table>
        </div>
        </div>
        </div>
        <form></form>
        `;
    }
}
